
function submitNewsletter(form) {

    let email = $('#newsletter-mail').val();

    if (email.length === 0 || !isEmail(email)) {
        var modal = new Modal({
            "title": $('.block-newsletter').data('translate-error-heading'),
            "content": $('.block-newsletter').data('translate-error-text'),
            "buttons": [
                '<button type="button" class="btn btn-primary" data-dismiss="modal">' + $('.block-newsletter').data('translate-error-button') + '</button>'
            ]
        });

    } else {

        $.ajax({
            url: $('body').data('domain') + "/frontend/functions/newsletter.subscribe.php",
            type: "POST",
            dataType: "json",
            data: {
                "email": email,
                "g-recaptcha-response": $(form).find(".g-recaptcha-response").val()
            },
            success: function (data) {

                var modal = new Modal({
                    "title": $('.block-newsletter').data('translate-succes-heading'),
                    "content": $('.block-newsletter').data('translate-succes-text'),
                    "buttons": [
                        '<button type="button" class="btn btn-primary" data-dismiss="modal">' + $('.block-newsletter').data('translate-succes-button') + '</button>'
                    ]
                });

                $('#inputEmail').val('');
                $('.submit-newsletter').addClass("disabled");
            },
            error: function(){
                grecaptcha.reset();
            }
        });

    }


}

function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

$(document).ready(function () {
    
    $('.newsletter-checkbox').on('click', function () {

        $('.submit-newsletter').addClass('disabled');

        if ($('.newsletter-checkbox').is(':checked') &&
            isEmail($('#newsletter-mail').val()) != '') {

            $('.submit-newsletter').removeClass("disabled");
        }
    });
    
    $('#newsletter-mail').on('keyup', function () {

        if (isEmail($(this).val()) &&
            $('.newsletter-checkbox').is(':checked')) {

            $('.submit-newsletter').removeClass("disabled");
        }
    });
});

